import React, { useEffect, useState } from 'react'
import { Dialog, Button, TextField, Grid, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { Auth } from 'aws-amplify'
import { contactEmail } from 'config'

const inputLabelProps = {
  classes: {
    shrink: 'text-black font-bold',
    focused: 'text-primary',
  },
}

const VerifyMFACodeDialog = ({ open, onClose, onSuccess, user }) => {
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    setCode('')
    setError('')
  }, [open])

  const handleVerifyClick = async () => {
    if (loading || !code) return
    setLoading(true)
    setError('')
    try {
      await Auth.confirmSignIn(user, code, user?.challengeName)
      onSuccess()
    } catch (error) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <h4 className="capitalize m-0 mb-4">
        Verify Multi-factor authentication
      </h4>

      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Typography>
            {user?.challengeName === 'SMS_MFA'
              ? 'Enter the code we sent to your phone number (SMS)'
              : 'Enter the code generated by your Authenticator App'}
          </Typography>
        </Grid>

        <Grid item sm={12}>
          <TextField
            autoFocus
            label={'Enter code:'}
            value={code}
            onChange={(event) => {
              if (error) setError('')
              setCode(event.target.value)
            }}
            InputLabelProps={inputLabelProps}
            variant="outlined"
            size="small"
            error={!!error}
            helperText={error}
            fullWidth
            onKeyPress={(event) => {
              if (event.key === 'Enter') handleVerifyClick()
            }}
          />
          <div className='text-12 mt-2 text-right'>
            Need help?{' '}<a href={`mailto:${contactEmail}`} style={{ color: '#4A90E2' }} >Contact us</a>
          </div>
        </Grid>
      </Grid>
      <div className="flex justify-start pt-2 m--2">
        <Button
          className="m-2 rounded hover-bg-primary px-6"
          variant="outlined"
          color="primary"
          disabled={loading || !code}
          onClick={handleVerifyClick}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Verify
        </Button>
        <Button
          className="m-2 rounded hover-bg-error px-6"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  )
}

export default VerifyMFACodeDialog
